import { styled } from "styled-system/jsx";

export const OrganizationSettingsViewButton = styled("button", {
  base: {
    fontFamily: "body",
    display: "flex",
    alignItems: "center",
    gap: "100",
    borderLeft: "3px solid",
    borderLeftColor: "transparent",
    pl: "200",
    py: "100",
    ml: "-2px",
    w: "full",
    borderTopRightRadius: "50",
    borderBottomRightRadius: "50",
    cursor: "pointer",
    color: "text.light",
    transitionDuration: "normal",
    transitionProperty: "border-color, color, outline-color, background",
    transitionTimingFunction: "default",
    _hover: {
      borderLeftColor: "border.light",
      color: "text.mid",
    },
    _focusVisible: {
      borderLeftColor: "border.light",
      color: "text.mid",
      outlineColor: "border.light",
      outlineStyle: "solid",
      outlineWidth: "1px",
    },
    _selected: {
      borderLeftColor: "border.dark",
      color: "text.dark",
      _hover: {
        borderLeftColor: "border.dark",
        color: "text.dark",
      },
      _focusVisible: {
        borderLeftColor: "border.dark",
        color: "text.dark",
        outlineColor: "border.light",
        outlineStyle: "solid",
        outlineWidth: "1px",
      },
    },
  },
});
